import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const NicknameForm = ({ send }) => {
  const [value, setValue] = useState("");
  const submit = (e) => {
    e.preventDefault();
    send({ type: "choose_nickname", nickname: value });
  };
  return (
    <form onSubmit={submit} className="space-y-4 py-6" data-testid="nickname-form">
      <p className="eyebrow">Sohbet Tahmin</p>
      <h2 className="font-display text-3xl font-black">Takma adını seç</h2>
      <p className="text-slate-300">Tahtada ve sohbette gerçek adın yerine bu ad görünecek. Uygun bir ad seç; öğretmenin değiştirebilir.</p>
      <Input value={value} onChange={(e) => setValue(e.target.value)} maxLength={16} placeholder="Takma ad (2-16 karakter)"
        className="h-14 text-xl" data-testid="nickname-input" autoComplete="off" />
      <Button type="submit" disabled={value.trim().length < 2} className="w-full h-14 text-lg font-bold" data-testid="nickname-submit">Devam</Button>
    </form>
  );
};
